export const trimValue = <T>(v: T): T =>
  (typeof v === "string" ? (v as unknown as string).trim() : v) as T;

export const dollarFormat = (num: number | undefined) => {
  const value = num ?? 0;
  const abs = Math.abs(value);

  if (abs >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  }

  if (abs >= 1_000) {
    return `$${(value / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  }

  return `$${value.toFixed(0)}`;
};

export const formatNumber = (value: number) => {
  const rounded = Math.round(value * 1000) / 1000;
  return rounded.toLocaleString("en-US", { maximumFractionDigits: 3 });
};

// e.g. "john@example.com" -> "j…@…"
export const maskEmail = (email: string): string => {
  const [local] = email.split("@");
  return local ? `${local[0]}…@…` : email;
};
